import React, { useState } from "react";
import { BASE_URL } from "../config/api";
import { useNavigate } from "react-router-dom";

const AddStaff = () => {
  const navigate = useNavigate();

  // Labels for role checkboxes based on SQL table
  const roleLabels = {
    // attendance: "Attendance",
    cash: "Cash Wallet",
    fine: "Fine Wallet",
    watchman: "Watchman",
    ovisit: "Outdoor Visits",
    svisit: "Sales Visits",
    // plating: "Plating",
    // leave_status: "Leave Module",
    task: "Task",
    reminder: "Reminder",
    // vpp: "VPP",
    // safe: "Safe Module",
    meter: "Meter Module",
    slead: "Sales Leads",
    check_in: "In-Out Products",
    sstock: "Sales Stock",
    parcel: "Parcel",

    // check_out: "Check Out",
    bazar: "Bazar Work",
    // cateloge: "Forming Catalogue",
    // olead: "Order Leads",
    ostock: "Office Stock",
    rstock: "Row Stock",
    // bill: "Bill",
    report: "Report",
    // allorder: "All Orders",
    // neworder: "New Orders",
    // korder: "K Orders",
    // dorder: "D Orders",
    // deliverd: "Delivered",
    // cancelled: "Cancelled",
    customer: "Customer",
    // logs: "Logs",
    // gold: "Gold Catalogue", // extra from your earlier form
  };

  const [staffData, setStaffData] = useState({
    name: "",
    number: "",
    email: "",
    password: "",
    inside_outside: "inside",
    reference_name: "",
    reference_number: "",
    address: "",
    ...Object.fromEntries(Object.keys(roleLabels).map((k) => [k, 0])),
  });

  const [fileData, setFileData] = useState({
    aadhaar_card_image: null,
    pan_card_image: null,
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;
    if (type === "file") {
      setFileData((prev) => ({ ...prev, [name]: files[0] }));
    } else if (type === "checkbox") {
      setStaffData((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
    } else {
      setStaffData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (
      !staffData.name ||
      !staffData.number ||
      !staffData.email ||
      !staffData.password
    ) {
      setError("Name, Number, Email, and Password are required.");
      return;
    }

    try {
      const formDataToSend = new FormData();
      Object.keys(staffData).forEach((key) =>
        formDataToSend.append(key, staffData[key])
      );

      if (fileData.aadhaar_card_image)
        formDataToSend.append(
          "aadhaar_card_image",
          fileData.aadhaar_card_image
        );
      if (fileData.pan_card_image)
        formDataToSend.append("pan_card_image", fileData.pan_card_image);

      // 1. Create staff with form data (including images)
      const staffRes = await fetch(`${BASE_URL}staff`, {
        method: "POST",
        body: formDataToSend,
      });
      const staffResult = await staffRes.json();

      if (staffResult.status !== 1) {
        setError(staffResult.error || "Failed to create staff.");
        return;
      }

      const staffId = staffResult.data.id;

      // 2. Assign roles
      const rolesData = { staff_id: staffId };
      Object.keys(roleLabels).forEach((key) => {
        rolesData[key] = staffData[key] || 0;
      });

      const roleRes = await fetch(`${BASE_URL}roles`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(rolesData),
      });

      const roleResult = await roleRes.json();

      if (roleResult.message?.toLowerCase().includes("success")) {
        alert("Staff and roles created successfully!");
        navigate("/StaffList");
      } else {
        setError("Staff created but failed to assign roles.");
      }
    } catch (err) {
      console.error(err);
      setError("An error occurred while creating staff.");
    }
  };

  return (
    <div id="main">
      <div className="page-heading">
        <h3>Add Staff</h3>
      </div>

      <section className="section">
        <div className="card">
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={staffData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Number</label>
                <input
                  type="text"
                  name="number"
                  className="form-control"
                  value={staffData.number}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={staffData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  value={staffData.password}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Location</label>
                <select
                  name="inside_outside"
                  className="form-control"
                  value={staffData.inside_outside}
                  onChange={handleChange}
                >
                  <option value="inside">Inside</option>
                  <option value="outside">Outside</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Reference Name</label>
                <input
                  type="text"
                  name="reference_name"
                  className="form-control"
                  value={staffData.reference_name}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Reference Number / Salary</label>
                <input
                  type="number"
                  name="reference_number"
                  className="form-control"
                  value={staffData.reference_number}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  name="address"
                  className="form-control"
                  value={staffData.address}
                  onChange={handleChange}
                />
              </div>
              <div className="row">
                {Object.keys(roleLabels).map((key) => (
                  <div className="col-md-3 mb-3" key={key}>
                    <label className="form-label">
                      <input
                        type="checkbox"
                        name={key}
                        className="form-check-input me-2"
                        checked={staffData[key] === 1}
                        onChange={handleChange}
                      />
                      {roleLabels[key]}
                    </label>
                  </div>
                ))}
              </div>

              <button type="submit" className="btn btn-primary mt-3">
                Add Staff
              </button>
              <button
                type="button"
                className="btn btn-secondary mt-3 ms-2"
                onClick={() => navigate("/StaffList")}
              >
                Back
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddStaff;
